<template>
  <div class="modal is-active"  >
         
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head is-size-4">
        
            </header>
            <section class="modal-card-body">

              <pre>  {{dataToChild}} </pre>
               
            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="close">Cancel</b-button>
            </footer>
        </div>
    </div>
</template>


<script>
// import axios from "axios"
// import {   getBaseURLforBackEnd , getConfigAxios   } from '@/utils.js'
// import { mapState } from "vuex";


export default {
    name : "DlgDetailPayloadEachTime",
    computed:{
        // ...mapState({
        //         access_token : state => state.master_data.access_token,
        //     }) ,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    props:{
         dataToChild : Object,
         isActive : Boolean,
         
    },
    methods:{
       close(){
        this.$emit('close')
       }
      
       
        
         
 
         

    },
    data(){
        return {
         
        }
    },
   
}
</script>